import NavBar from '../components/Navbar'
export default function About(){
    return (
<>
    <NavBar/>
    <h1>About</h1>
</>
    );
}